import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { isMgbwWebsite } from "@tSurya/Common/Utilities/websiteUtils";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

// On MGBW the Projects page is forced to Surya styling (SuryaPageThemeWrapper).
// Surya buttons have no hover effect, but Mobius darkens the button color by 0.3
// on :hover / :active. Pin the hover/active/focus state back to the button's rest
// colors so MGBW matches Surya. Evaluated at render time (arrow function) so the
// brand check runs on the client and is SSR-safe; no-op for Surya / Global Views.
// `_color` is the resolved rest color Mobius passes to the ButtonWrapper, so the
// hover background ends up identical to the rest background regardless of variant.
const removeButtonHoverForMgbw = css`
    ${({ theme, _color }: { theme: BaseTheme; _color?: string }) =>
        isMgbwWebsite()
            ? css`
                  &:not(:disabled):hover,
                  &:not(:disabled):active,
                  &:not(:disabled):focus {
                      background: ${resolveColor(_color, theme)} !important;
                      border-color: ${resolveColor(_color, theme)} !important;
                      /* Solid primary button: keep the text white on hover to match
                         Surya (which has no hover). The global MGBW button theme
                         otherwise darkens the label via a :hover span color rule.
                         White is the rest contrast color; getColor("primary.contrast")
                         is unreliable here because this css context sees a flattened
                         theme where colors.primary is a string. */
                      color: #ffffff !important;
                      span[class^="TypographyStyle"] {
                          color: #ffffff !important;
                      }
                  }
              `
            : null}
`;

const removeOutlineButtonHoverForMgbw = css`
    ${({ theme, _color }: { theme: BaseTheme; _color?: string }) =>
        isMgbwWebsite()
            ? css`
                  &:not(:disabled):hover,
                  &:not(:disabled):active,
                  &:not(:disabled):focus {
                      color: ${resolveColor(_color, theme)} !important;
                      border-color: ${resolveColor(_color, theme)} !important;
                      background: transparent !important;
                      span[class^="TypographyStyle"] {
                          color: ${resolveColor(_color, theme)} !important;
                      }
                  }
              `
            : null}
`;

wishListCardStyles.actionAddToCartButton = {
    variant: "primary",
    css: css`
        white-space: nowrap;
        width: 100%;
        padding-left: 0;
        padding-right: 0;
        ${removeButtonHoverForMgbw}
    `, // keep text from wrapping
};

wishListCardStyles.actionDeleteButton = {
    variant: "secondary",
    css: css`
        width: 100%;
        margin-top: 10px;
        ${() =>
            isMgbwWebsite()
                ? css`
                      span[class^="TypographyStyle"] {
                          color: #545454 !important;
                          font-weight: 400 !important;
                      }
                  `
                : null}
        ${removeOutlineButtonHoverForMgbw}
    `,
};
wishListCardStyles.detailLinkGridItem = {
    width: 12,
    css: css`
        a {
            span {
                color: ${getColor("text.link")} !important;
                font-size: ${TYPOGRAPHY.size.large};
                font-weight: ${TYPOGRAPHY.weight.mediumbold};
                //text-transform: uppercase;
                &:hover {
                    color: ${getColor("text.link")} !important;
                    text-decoration-line: underline;
                }
            }
        }
    `,
};
wishListCardStyles.gridContainer = {
    gap: 5,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        margin-bottom: 15px;
                    `,
                    css`
                        margin-bottom: 15px;
                    `,
                    css`
                        margin-bottom: 15px;
                    `,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};

wishListCardStyles.actionGridItem = {
    width: [2, 2, 4, 4, 2],
    align: "top",
    css: css`
        justify-content: flex-end;
    `,
};

wishListCardStyles.wishListInfoGridItem = {
    width: [10, 10, 8, 8, 10],
    align: "middle",
};
